<div class="modal-header">
    <h4 class="modal-title">Configurar Alertas de Visto Bueno</h4>
    <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <h6>Ingresa el texto de la alerta para cada formulario:</h6>

    <div *ngIf="selectedVobos.length === 0" class="text-muted text-center mt-3">
        No hay formularios de VoBo seleccionados.
    </div>

    <div class="container-fluid px-0">
        <div *ngFor="let vobo of selectedVobos" class="row align-items-center mb-3">
            <div class="col-md-4">
                <label class="form-label mb-0">{{ vobo.nombre }}</label>
            </div>
            <div class="col-md-8">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Escriba la alerta</mat-label>
                    <input matInput 
                           [value]="getAlertText(vobo.id)"
                           (input)="updateAlertText(vobo.id, $event)"
                           placeholder="Ej: Favor de revisar el costo">
                    <button *ngIf="getAlertText(vobo.id)" matSuffix mat-icon-button aria-label="Clear" (click)="clearAlertText(vobo.id)">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button mat-stroked-button (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="save()">Guardar</button>
</div>
